import { UploadGuideModal } from "@/components/flowly/UploadGuideModal/UploadGuideModal";
import { useLanguage } from "@/contexts/LanguageContext";
import { PROFILE_PHOTO_GUIDE_IMAGE } from "@/config/profilePhotoPresets";

interface TalkingAvatarUploadGuideProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Talking-avatar copy for the shared upload-guide popup — stresses that the
 *  character's face must be close to the camera for good lip-sync. Reuses the
 *  profile-photo reference image (a clear, close-up, face-forward portrait). */
export function TalkingAvatarUploadGuide({
  isOpen,
  onClose,
}: TalkingAvatarUploadGuideProps) {
  const { t } = useLanguage();
  return (
    <UploadGuideModal
      isOpen={isOpen}
      onClose={onClose}
      imageSrc={PROFILE_PHOTO_GUIDE_IMAGE}
      title={t.talkingAvatar.guideModalTitle}
      body={t.talkingAvatar.guideModalBody}
      imageCaption={t.talkingAvatar.guideImageCaption}
      ctaLabel={t.talkingAvatar.guideModalCta}
    />
  );
}
